import { all, fork, put, takeEvery } from "redux-saga/effects";
import * as api from "../../api";

import { FETCH_PROJECTS } from "../actions";

import { fetchProjectsSuccess, fetchProjectsError } from "./actions";

function* fetchAllProjects() {
  const res = yield api.getData("/project");

  if (res.status === 200) {
    const data = yield res.json();
    yield put(fetchProjectsSuccess(data));
  } else {
    yield put(fetchProjectsError(res.error.message));
  }
}

// function* updateProject(data) {
//   const res = yield api.postData('/project', data);
//   if (res.status === 200) {
//     yield put(setProject(data))
//   }
// }
//
// function* watchUpdateProject() {
//   return yield takeEvery(UPDATE_PROJECT, updateProject);
// }

function* watchFetchProjects() {
  return yield takeEvery(FETCH_PROJECTS, fetchAllProjects);
}

export default function* rootSaga() {
  yield all([fork(watchFetchProjects)]);
}
